export default __webpack_public_path__ + "static/media/photo-kontakt.6105030a.jpg";